import {useContext} from 'react';
import {AppNavigationContext} from '../types';

export const useAppNavigationContext = () => {
  const context = useContext(AppNavigationContext);
  if (!context) {
    throw Error('Could not find Team Context');
  }
  return context;
};
